/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { getBreakpointFromWidth, getColsFromBreakpoint } from 'react-grid-layout/build/responsiveUtils';

/*
 * A simple HOC that provides facility for listening to container resizes.
 */
export default function WidthProvider(ComposedComponent) {
  return class WidthProvider extends React.Component {
    static defaultProps = {
      measureBeforeMount: true,
    };

    static propTypes = {
      // If true, will not render children until mounted. Useful for getting the exact width before
      // rendering, to prevent any unsightly resizing.
      measureBeforeMount: PropTypes.bool,
    };

    constructor(props) {
      super(props);
      this.state = {
        width: 1280,
      };
    }

    mounted = false; // eslint-disable-line

    componentDidMount() {
      this.mounted = true;

      window.addEventListener('resize', this.onWindowResize);
      // Call to properly set the breakpoint and resize the elements.
      // Note that if you're doing a full-width element, this can get a little wonky if a scrollbar
      // appears because of the grid.
      // In that case, fire your own resize event, or set `overflow: scroll` on your body.
      this.onWindowResize();
    }

    componentWillUnmount() {
      this.mounted = false;
      window.removeEventListener('resize', this.onWindowResize);
    }

    onBreakpointChange = (newBreakpoint, newCols) => {
      this.props.onBreakpointChange(newBreakpoint, newCols);
    };

    onWindowResize = () => {
      if (!this.mounted) return;
      // Delay width calculation slightly due to animation that change the width
      // See https://github.com/STRML/react-grid-layout/issues/817
      setTimeout(this.updateWidth, 200)
    };

    updateWidth = () => {
      try {
        const node = ReactDOM.findDOMNode(this);
        if (node && node instanceof HTMLElement) {
          this.setState(prevState => {
            const width = node.offsetWidth;
            if (prevState.width !== width) {
              const newBreakpoint = getBreakpointFromWidth(this.props.breakpoints, node.offsetWidth);
              const newCols = getColsFromBreakpoint(newBreakpoint, this.props.cols);
              this.onBreakpointChange(newBreakpoint, newCols);
            }
            return { width }
          });
        }
      } catch (e) {}
    };

    render() {
      const { measureBeforeMount, onBreakpointChange, ...rest } = this.props;
      if (measureBeforeMount && !this.mounted) {
        return (
          <div className={this.props.className} style={this.props.style} />
        );
      }

      return (
        <ComposedComponent
          {...rest}
          {...this.state}
        />
      );
    }
  };
}
